import RefreshButton from '../../../atoms/RefreshButton';
import { TopologyResource } from './hooks/useTopology';
import { formatDateTime } from './shared/format';

const TopologyRefresh = ({ topology }: { topology: TopologyResource }) => (
  <div className="flex items-center justify-end gap-3">
    <span className="text-xs text-gray-500 dark:text-gray-400">topologia atualizada {formatDateTime(topology.loadedAt)}</span>
    <RefreshButton variant="primary" label="a topologia" busy={topology.loading} onClick={topology.reload} />
  </div>
);

export default TopologyRefresh;
